<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Insurance</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Insurance
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-body">
                    <form novalidate @submit.prevent="saveInsurance">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Name</label>
                                        <input type="text" v-model="insurance.name" class="form-control"
                                               placeholder="Name"
                                               required>
                                        <div v-if="insurance.errors.name" class="text-danger text-small">
                                            {{ insurance.errors.name }}
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Status</label>
                                        <select type="text" v-model="insurance.is_active" class="form-control" required>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                        <div v-if="insurance.errors.is_active" class="text-danger text-small">
                                            {{ insurance.errors.is_active }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Description</label>
                                        <input type="text" v-model="insurance.description" class="form-control"
                                               placeholder="Description"
                                               required>
                                        <div v-if="insurance.errors.description" class="text-danger text-small">
                                            {{ insurance.errors.description }}
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Rate Percentage (%)</label>
                                        <input type="text" v-model="insurance.rate_percentage" class="form-control"
                                               placeholder="Rate Percentage"
                                               required>
                                        <div v-if="insurance.errors.rate_percentage" class="text-danger text-small">
                                            {{ insurance.errors.rate_percentage }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button type="submit" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                        :disabled="saving">
                                    {{ isEditing ? 'Update' : 'Save' }}
                                    <i class="fa fa-spinner fa-spin" v-if="saving"/>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import vueFilePond from "vue-filepond"
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";

export default {
    metaInfo: {title: 'Create Insurance'},
    name: 'Insurance',
    props: ['isEditing', 'insuranceData'],
    layout: Layout,
    data() {
        return {
            insurance: this.$inertia.form({
                name: null,
                description: null,
                is_active: 1,
                rate_percentage: null,
            }),
            saving: false,
        }
    },
    methods: {
        async saveInsurance() {
            this.saving = true;

            if (this.isEditing) {
                this.insurance.put(
                    route('admin.insurances.update', this.insuranceData.id),
                    {...this.insurance},
                    {
                        forceFormData: true,
                        preserveScroll: true,
                        onSuccess: () => this.saving = false,
                        onError: () => {
                            this.saving = false;
                        }
                    }
                );
            } else {
                this.insurance.post(route('admin.insurances.store'), this.insurance, {
                    forceFormData: true,
                    preserveScroll: true,
                    onSuccess: () => this.saving = false,
                    onError: () => {
                        this.saving = false;
                    }
                });
            }

            this.saving = false;
        }
    },
    mounted() {
        if (this.isEditing) {
            this.insurance.name = this.insuranceData.name
            this.insurance.description = this.insuranceData.description
            this.insurance.is_active = this.insuranceData.is_active ? 1 : 0
            this.insurance.rate_percentage = this.insuranceData.rate_percentage
        }
    },
}
</script>
